import { styled } from 'styled-components';

import CommonRibbon from '../../Ribbon';

export const Ribbon = styled(CommonRibbon)`
  display: none;
  left: 50%;
  position: absolute;
  top: var(--spacing-small);
  transform: translateX(-50%);

  a {
    min-width: var(--spacing-small);
    padding: var(--spacing-tiny);
  }

  @media (hover: none) {
    display: flex;
  }
`;
